import React, { FC } from 'react';

import { Stack } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import {
  DetailsIdentifier,
  formatNumberWithComma,
  renderSeverityBar,
} from 'components/DataDisplay';
import { selectCompliance } from 'containers/Compliance/selectors';

interface Props {
  resource?: Record<string, any>;
  blueprint?: Record<string, any>;
  policyDescription?: string;
  severity?: string;
  applicableEntities?: number;
}

export const ComplianceChartDetails: FC<Props> = props => {
  const {
    blueprint,
    policyDescription,
    severity,
    applicableEntities,
    resource,
  } = props;
  const { selectedBlueprint } = useSelector(selectCompliance);

  return (
    <Stack spacing={4}>
      <DetailsIdentifier
        label="Blueprint"
        value={blueprint?.name ?? selectedBlueprint?.name}
      />
      {policyDescription && (
        <DetailsIdentifier
          label="Policy Description"
          isInline={false}
          spacing={0}
          value={policyDescription}
        />
      )}
      {severity && (
        <DetailsIdentifier
          label="Severity"
          value={renderSeverityBar({ value: severity })}
        />
      )}
      {!!resource?.control && (
        <DetailsIdentifier
          label="Applicable Entities"
          value={formatNumberWithComma(applicableEntities)}
        />
      )}
    </Stack>
  );
};
